export enum NewVersionModeEnum {
  KEEP_CURRENT = 'KEEP_CURRENT',
  RETIRE_NOW = 'RETIRE_NOW',
}

export const NEW_VERSION_MODES = [NewVersionModeEnum.KEEP_CURRENT, NewVersionModeEnum.RETIRE_NOW];
